<!-- <dashboard-scrollable-content> -->
<div class="grid-container">
	<div id="viz1" class="chart-container"></div>
	<div id="viz2" class="chart-container"></div>
	<div id="viz3" class="chart-container"></div>
	<div id="viz4" class="chart-container"></div>
</div>
<!-- </dashboard-scrollable-content> -->